import {management} from '../../../index.js' //api
import {RainfallRepository} from '../../infra/knex/repositories/rainfall'

import {GetRainfallSinceFirstLogUseCase} from './getRainfallSinceFirstLog'

export const getRainfallSinceFirstLogUseCase=new GetRainfallSinceFirstLogUseCase(new RainfallRepository(management))
